// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { openBidsDetailsInformationStyles } from "@steiner/App/Widgets/OpenBidsDetails/OpenBidsDetailsInformation";
import { css } from "styled-components";

openBidsDetailsInformationStyles.detailsGridContainer = {
    gap: 0,
};

openBidsDetailsInformationStyles.infoGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        & > div {
            display: flex;
        }
    `,
};

openBidsDetailsInformationStyles.infoHeadingAndText = { ...xOrderInformationStyles.headingAndTextStyles };

openBidsDetailsInformationStyles.dateLabelText = {
    ...xOrderInformationStyles.labelWithDots,
    css: css`
        margin-bottom: 4px;
        margin-right: 4px;
    `,
};
openBidsDetailsInformationStyles.dateLabelValue = { ...xOrderInformationStyles.value };
